import { Injectable, inject } from '@angular/core';
import { OrderSecurity } from '../../../../../../domain/security.domain';
import { BackendMapper, ORDER_ENTRY_MAPPER } from '../../../domain/services.domain';
import { OrderEntryFormModel } from '../../../domain/order-entry.domain';

@Injectable()
export  class CreateOrderMapperFactory {
  private readonly mappers = inject<Array<BackendMapper<OrderEntryFormModel>>>(ORDER_ENTRY_MAPPER);

  getInstance<T extends OrderEntryFormModel>(productType: OrderSecurity): BackendMapper<T> {
    return this.mappers.find((m: BackendMapper<T>): boolean => m.getMapperType() === productType );
  }
}

